import { render } from "./WarningMenu.vue?vue&type=template&id=489c7cc5&scoped=true"
import script from "./WarningMenu.vue?vue&type=script&lang=js"
export * from "./WarningMenu.vue?vue&type=script&lang=js"

import "./WarningMenu.vue?vue&type=style&index=0&id=489c7cc5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489c7cc5"]])

export default __exports__